import { LostFocusEventArgs as LostFocusEventArgs_internal } from "./LostFocusEventArgs";
var IgrLostFocusEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrLostFocusEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrLostFocusEventArgs.prototype.createImplementation = function () {
        return new LostFocusEventArgs_internal();
    };
    Object.defineProperty(IgrLostFocusEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrLostFocusEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrLostFocusEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    return IgrLostFocusEventArgs;
}());
export { IgrLostFocusEventArgs };
//# sourceMappingURL=igr-lost-focus-event-args.js.map
